<!--currentJobDetails - object that comes back from SQL
    jobDetails - object ui uses and is set from currentjobDetails upon retrieval from sql
    jobInfo - object which stores all possibilities of farms. job descs etc... -->
<template>
    
  <v-container>
    <v-card>
      <v-card-title class="headline" style="margin-bottom:10px">Job Details</v-card-title>
    </v-card>
    <v-card></v-card>
    <v-card class="mb-3" v-if="shiftInProgress == '0'">
      <v-card-title><h3 class="title">Editing Historic Timesheet</h3></v-card-title>
      <v-card-text>
        {{ shiftStartTime | formatDate}} - {{ shiftEndTime | formatDate}}
<br><br>
        The start & end times of jobs is restricted to fall within the timesheet.
      </v-card-text>
    </v-card>
    <v-card class="pa-0">
      <v-dialog v-model="saveFailedDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Failed to update job</v-card-title>
          <v-card-text>Failed to update job on the server, please try again</v-card-text>
          <v-card-actions>
            <v-btn color="red darken-1" flat to="/">Back to Overview</v-btn>
            <v-btn color="red darken-1" @click="saveFailedDialog = false">Dismiss</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="failedDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Connection Failed</v-card-title>
          <v-card-text>Failed to retrieve data from the server, please check your connection and try again</v-card-text>
          <v-card-actions>
            <v-btn color="red darken-1" flat to="/">Back to Overview</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="completeDialog" max-width="500" persistent transition="dialog-bottom-transition">
        <v-card tile>
          <v-toolbar card dark color="primary">
            <v-toolbar-title>Job Entry Successful</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark :to="'/'">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-btn color="mt-3 grey darken-1" block dark :to="'/Expenses'"><v-icon>receipt</v-icon> Add Expenses</v-btn>
            <v-btn color="mt-3 green darken-1" block dark @click="completeDialog = false"><v-icon>assignment</v-icon> Start Another Job</v-btn>
            <v-btn color="mt-3 red darken-1" block dark to="/TimesheetEntry/out"><v-icon>file_upload</v-icon> Clock Out</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="startDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Job Start Saved</v-card-title>
          <v-card-text>You have successfully recorded the start a job.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat to="/">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="errorDialog" persistent>
        <v-card>
          <v-card-title class="headline">Offline</v-card-title>
          <v-card-text>
            <v-alert v-model="errorDialog" icon="cloud_off" type="error">You are currently offline, Please try again later</v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat to="/">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteConfirmDialog" persistent>
        <v-card>
          <v-card-title class="headline">Delete Job</v-card-title>
          <v-card-text>
            <v-alert v-model="deleteConfirmDialog" icon="delete" type="error">Are you sure you want to delete this job? This cannot be undone!</v-alert>
          </v-card-text>
          <v-card-actions>
            <v-btn color="green darken-1" flat @click="deleteConfirmDialog = false">Cancel</v-btn>
            <v-spacer/>
            <v-btn color="red darken-1" flat @click="deleteConfirmDialog = false; deleteJob()">Delete Job</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-container>
        <v-form v-model="formValid" ref="form" lazy-validation>
          <v-card class="pa-2" :elevation="jobState === 1 ? '2' : '0'" :color="jobState === 1 ? 'grey lighten-5' : ''">
            <v-dialog
              ref="startDateDialog"
              persistent
              v-model="startDateDialog"
              lazy
              full-width
              width="290px"
              :return-value.sync="jobDetails.startDate"
              :disabled="!shiftInProgress && (!endJobActive || loading)"
            >
              <v-text-field
                slot="activator"
                label="Start Date"
                v-model="formatStartDate"
                prepend-icon="event"
                readonly
               :disabled="!shiftInProgress && (!endJobActive || loading)"
              ></v-text-field>
              <v-date-picker 
                v-model="jobDetails.startDate" 
                actions 
                full-width
                :disabled="!shiftInProgress && (!endJobActive || loading)"
                :min="shiftStartTime != null ? shiftStartTime.split(' ')[0] : null"
                :max="shiftInProgress == '0' && shiftEndTime != null ? shiftEndTime.split(' ')[0] : null">
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="startDateDialog = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.startDateDialog.save(jobDetails.startDate); validateForm()">OK</v-btn>
              </v-date-picker>
            </v-dialog>
            <v-dialog
              ref="startTimeDialog"
              persistent
              v-model="startTimeDialog"
              lazy
              full-width
              width="fit-content"
              :return-value.sync="jobDetails.startTime"
              :disabled="!shiftInProgress && (!endJobActive || loading)"

            >
              <v-text-field
                slot="activator"
                label="Start Time"
                v-model="startTimeFormat"
                :rules="startTimeRules"
                prepend-icon="access_time"
                readonly
                :disabled="!shiftInProgress && (!endJobActive || loading)"
                ></v-text-field>
              <b-timepicker
                inline
                size="is-large"
                placeholder="Click to select..."
                icon="clock"
                v-model="jobDetails.startTime"
                :time-parser="formatTimeStringToDate"
                :time-format="formatTimeDateToString"
                :min-time="startMinTime"
                :max-time="maxStartTime"
                hour-format="24"
                :disabled="loading"
                >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="startTimeDialog = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.startTimeDialog.save(jobDetails.startTime)">OK</v-btn>
            </b-timepicker>
            </v-dialog>
            <v-autocomplete
              label="Select Farm"
              v-model="jobDetails.farm"
              :items="filteredFarms"
              :disabled="!shiftInProgress && (!endJobActive || loading)"
              item-value="ID"
              :rules="inputRules"
              item-text="farm_name"
            >
            </v-autocomplete>
            <v-autocomplete
              label="Job Description"
              v-model="jobDetails.jobDescription"
              :items="filteredJobDesc"
              item-value="ID"
              :rules="inputRules"
              item-text="name"
              :disabled="!shiftInProgress && (!endJobActive || loading)"
            ></v-autocomplete>
            <v-autocomplete
              v-if="hasProductSpec"
              label="Product Specification"
              v-model="jobDetails.productSpec"
              :items="filteredProdSpec"
              item-value="ID"
              :rules="prodSpecRules"
              item-text="product_name"
              :disabled="!shiftInProgress && (!endJobActive || loading)">
            </v-autocomplete>
            <v-btn v-if="jobState === 0" class="primary my-2" :loading="loading" block @click="startJob" >Confirm Start</v-btn>
            <v-btn v-if="jobState === 1 && !endJobActive" class="default my-2" :loading="loading" block @click="openEndDialog()" >End Job</v-btn>
            <v-btn v-if="jobState !== 0" class="red darken-4 my-2" :loading="loading" block @click="deleteConfirmDialog = true">Delete Job</v-btn>
            <v-btn v-if="currentJobID !== -1 && loading" class="default my-2" :loading="loading" block disabled></v-btn>
          </v-card>
          <v-card class="pa-2 mt-1" elevation="0" v-if="endJobActive">
            <v-dialog
              ref="endDateDialog"
              persistent
              v-model="endDateDialog"
              lazy
              full-width
              width="290px"
              :return-value.sync="jobDetails.endDate"
              :disabled="loading || (!endJobActive && jobState !== 0)"

            >
              <v-text-field
                slot="activator"
                label="End Date"
                v-model="formatEndDate"
                prepend-icon="event"
                :rules="endDateRules"
                readonly
                :disabled="loading || (!endJobActive && !jobState == 0)"
              ></v-text-field>
              <v-date-picker 
                  v-model="jobDetails.endDate" 
                  actions 
                  full-width
                  :min="shiftInProgress == '0' && shiftStartTime != null ? shiftStartTime.split(' ')[0] : jobDetails.startDate.split(' ')[0]"
                  :max="shiftInProgress == '0' && shiftEndTime != null ? shiftEndTime.split(' ')[0] : null">
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="endDateDialog = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.endDateDialog.save(jobDetails.endDate)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
            <v-dialog
              ref="endTimeDialog"
              persistent
              v-model="endTimeDialog"
              lazy
              full-width
              width="fit-content"
              :return-value.sync="jobDetails.endTime"
              :disabled="loading || (!endJobActive && !jobState == 0)"
            >
              <v-text-field
                slot="activator"
                label="End Time"
                v-model="endTimeFormat"
                prepend-icon="access_time"
                :rules="endTimeRules"
                readonly
                :disabled="loading || (!endJobActive && !jobState == 0)"
              ></v-text-field>
              <b-timepicker
                inline
                size="is-large"
                placeholder="Click to select..."
                icon="clock"
                v-model="jobDetails.endTime"
                :time-parser="formatTimeStringToDate"
                :time-format="formatTimeDateToString"
                :min-time="endMinTime"
                :max-time="maxEndTime"
                hour-format="24"
                :disabled="loading || (!endJobActive && !jobState == 0)">
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="endTimeDialog = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.endTimeDialog.save(jobDetails.endTime)">OK</v-btn>
            </b-timepicker>
            </v-dialog>
            <template v-if="jobDetails.jobDescription == 0"><!-- if job description is spraying (as spraying id is 0), show the spray bonus value-->
              <v-layout row wrap>
                <v-flex xs12>
                  <label>Spray Bonus</label>
                </v-flex>
                <v-flex xs2>
                  <v-text-field v-model="jobDetails.spray_bonus" min="0" step="1" pattern="[0-9]*" type="number" :rules="sprayBonusRules" @input="stripDecimals"/>
                </v-flex>
                <v-flex xs7>
                  <p style="font-size:20px; margin-top:16px; margin-bottom:0">Hectares</p>
                </v-flex>
              </v-layout>
            </template>
            <template v-if="formValid">
              <div>
                <strong :class="jobBackwards ? 'red--text' : ''">{{formattedJobLength}}</strong>
              </div>
            </template>
            <v-btn class="primary my-2" v-if="jobState != 2" :loading="loading" block @click="endJobActive = false" >Cancel</v-btn>
            <v-btn class="success my-2" :loading="loading" block @click="completeJob">{{jobState == 1 ? 'Complete Job' : 'Update Job'}}</v-btn><!--also functions as the "change end" function for an already completed job-->
          </v-card>
        </v-form>
      </v-container>
    </v-card>
 </v-container>
</template>

<script>
import moment from 'moment'
import axios from 'axios'

export default {
  props: ['taID', 'shiftInProgress', 'jobID'],
  data () {
    return {
      jobInfo: {},
      jobDetails: {
        farm: null,
        spray_bonus: 0,
        jobDescription: null,
        productSpec: null,
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null,
        gps: null,
        job_id: null,
        ta_id: null
      },
      startTimeRules: [
        v => v !== null || 'Start time is required',
        v => (this.shiftInProgress !== '1' ? moment(this.jobDetails.startDate + ' ' + v).isBetween(this.shiftStartTime, this.shiftEndTime, null, '[]') : moment(this.jobDetails.startDate + ' ' + v, 'YYYY-MM-DD HH:mm').local().isSameOrAfter(this.shiftStartTime, 'YYYY-MM-DD HH:mm')) || 'Check job start time is within shift times',
        v => this.existingJobOverlap === false || 'Job times overlap with an existing job'
      ],
      endTimeRules: [
        v => v !== null || 'End time is required',
        v => this.jobBackwards !== true || 'End time must be after start time',
        v => (moment(this.jobDetails.endDate + ' ' + v).isBetween(moment(this.shiftStartTime, 'YYYY-MM-DD HH:mm'), moment(this.shiftEndTime, 'YYYY-MM-DD HH:mm'), null, '[]') || this.shiftEndTime == null) || 'Check job end time is within shift times',
        v => this.existingJobOverlap === false || 'Job times overlap with an existing job'
      ],
      endDateRules: [
        v => v !== null || 'End date is required',
        v => this.jobBackwards !== true || 'End date must be after start date',
        v => (moment(v, 'DD/MM/YYYY').isBetween(moment(this.shiftStartTime, 'YYYY-MM-DD'), moment(this.shiftEndTime, 'YYYY-MM-DD'), null, '[]') || this.shiftEndTime == null) || 'Check job end date is within shift times',
        v => this.existingJobOverlap === false || 'Job times overlap with an existing job'
      ],
      inputRules: [
        v => v !== null || 'Field is required'
      ],
      prodSpecRules: [
        v => ((v !== null) && (this.hasProductSpec === 1)) || 'Field is required'
      ],
      sprayBonusRules: [
        v => (v > 0 && this.jobDetails.jobDescription === 0) || 'Spray bonus must be set'
      ],
      startDateDialog: false,
      url: this.$store.getters.url,
      startTimeDialog: false,
      startTimeFormat: null,
      startDialog: false,
      endDateDialog: false,
      endTimeDialog: false,
      endTimeFormat: null,
      completeDialog: false,
      errorDialog: false,
      failedDialog: false,
      errorDateDialog: false,
      saveFailedDialog: false,
      deleteConfirmDialog: false,
      jobState: 0, // 0 - Not Start | 1 - Started | 2 - Ended
      empID: this.$store.getters.user.empID,
      company: this.$store.getters.company,
      loading: true,
      formValid: true,
      currentJobID: this.jobID === undefined ? -1 : this.jobID, // -1 if no job is selected
      endJobActive: false,
      shiftStartTime: null,
      shiftEndTime: null,
      jobStartTime: null,
      jobList: [],
      totalJobList: [],
      jobsLoaded: false
    }
  },
  mounted () {
    this.getAllJobs()
    if (this.currentJobID !== '-1') { // If an actual job is selected, get the details of the job
      this.getCurrentJobDetails()
    } else { // setup the times as it is a new job
      this.getShiftTimes()
      if (this.shiftInProgress === '1') {
        this.jobDetails.startDate = moment().format('YYYY-MM-DD')
        this.jobDetails.startTime = moment().toDate()
      }
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.jobDetails.gps = position.coords.latitude + ' ' + position.coords.longitude
      })
    }
    this.jobDetails.ta_id = this.taID
    this.retrieveJobInfo() // gets list of farms, job descriptions and product specificiations
  },
  watch: {
    'jobDetails.startTime': function (value) {
      this.startTimeFormat = moment(value).format('HH:mm')
      this.validateForm()
    },
    'jobDetails.endTime': function (value) {
      this.endTimeFormat = moment(value).format('HH:mm')
      this.validateForm()
    },
    'jobDetails.jobDescription': function (value) {
      this.validateForm()
      if (this.jobInfo.jobDescription !== undefined) {
        var jobDescObj = this.jobInfo.jobDescription.find(x => x.ID === value)
        if (jobDescObj !== null && jobDescObj.hasProduct === 0) {
          this.jobDetails.productSpec = null
        }
        this.jobDetails.spray_bonus = null // ensure spray bonus is always reset
      }
    },
    'jobDetails.startDate': function (value) {
      // let newStartTime = moment(value + ' ' + moment(this.jobDetails.startTime).format('HH:mm'), 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm')
      // if (moment(newStartTime).isSameOrBefore(moment(this.shiftStartTime))) {
      //   this.jobDetails.startTime = moment(this.shiftStartTime).toDate()
      // }
      this.validateForm()
    },
    'jobDetails.endDate': function (value) {
      this.validateForm()
      let newEndTime = moment(value + ' ' + moment(this.jobDetails.endTime).format('HH:mm'), 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm')
      if (moment(newEndTime).isSameOrAfter(moment(this.shiftEndTime))) {
        this.jobDetails.endTime = moment(this.shiftEndTime).toDate()
      }
    }
  },
  computed: {
    hasProductSpec () { // returns whether the selected job description contains product specifications
      let jobDescID = this.jobDetails.jobDescription
      let jobDescList = this.jobInfo.jobDescription
      if (jobDescList === undefined) {
        return 0
      }
      let jobDescObj = jobDescList.find(x => x.ID === jobDescID)
      if (jobDescObj === undefined) {
        return 0
      }
      return jobDescObj.hasProduct
    },
    formatStartDate () {
      return moment(this.jobDetails.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    formatEndDate () {
      return moment(this.jobDetails.endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    filteredFarms () {
      if (this.jobInfo.farms === undefined) {
        return []
      }
      return this.jobInfo.farms.sort((a, b) => a.farm_name.localeCompare(b.farm_name))
    },
    filteredJobDesc () {
      if (this.jobInfo.jobDescription === undefined) {
        return []
      }
      return this.jobInfo.jobDescription.sort((a, b) => a.name.localeCompare(b.name))
    },
    filteredProdSpec () {
      if (this.jobInfo.productSpec === undefined) {
        return []
      }
      return this.jobInfo.productSpec.sort((a, b) => a.product_name.localeCompare(b.product_name))
    },
    endMinTime () {
      const start = moment(this.jobDetails.startDate)
      const end = moment(this.jobDetails.endDate)
      console.log('ENDDIFF: ' + end.diff(start, 'days'))
      if (end.diff(start, 'days') >= 1) {
        console.log('end is a day after start')
        return moment('1970-01-01 00:00').toDate()
      }
      let jobStartTime = moment(this.jobDetails.startTime).format('HH:mm')
      return moment('1970-01-01 ' + jobStartTime).toDate()
    },
    startMinTime () {
      if (this.shiftStartTime == null) {
        return moment('1970-01-01 00:00').toDate()
      }
      let shiftStartTime = moment(this.shiftStartTime).format('HH:mm')
      let shiftStartDate = moment(this.shiftStartTime).format('YYYY-MM-DD')
      if (moment(this.jobDetails.startDate).isSameOrBefore(shiftStartDate)) {
        console.log('No end date set and job is same or before shift')
        return moment('1970-01-01 ' + shiftStartTime).toDate()
      }
      return moment('1970-01-01 00:00').toDate()
    },
    maxEndTime () {
      if (this.shiftStartTime == null) {
        return moment('1970-01-01 23:59').toDate()
      }
      let shiftEndTime = moment(this.shiftEndTime).format('HH:mm')
      let shiftEndDate = moment(this.shiftEndTime).format('YYYY-MM-DD')
      if (moment(this.jobDetails.endDate).isSameOrAfter(shiftEndDate) && this.shiftInProgress === '0') {
        return moment('1970-01-01 ' + shiftEndTime).toDate()
      }
      return moment('1970-01-01 23:59').toDate()
    },
    maxStartTime () {
      if (this.shiftEndTime == null) {
        return moment('1970-01-01 23:59').toDate()
      }
      let shiftEndTime = moment(this.shiftEndTime).format('HH:mm')
      let shiftEndDate = moment(this.shiftEndTime).format('YYYY-MM-DD')
      if (moment(this.jobDetails.startDate).isSameOrAfter(shiftEndDate) && this.shiftInProgress === '0') {
        return moment('1970-01-01 ' + shiftEndTime).toDate()
      }
      return moment('1970-01-01 23:59').toDate()
    },
    jobBackwards () {
      let startDate = moment(this.jobDetails.startDate).format('YYYY-MM-DD')
      let startTime = moment(this.jobDetails.startTime).format('HH:mm')
      let endDate = moment(this.jobDetails.endDate).format('YYYY-MM-DD')
      let endTime = moment(this.jobDetails.endTime).format('HH:mm')
      return moment(startDate + ' ' + startTime).isAfter(moment(endDate + ' ' + endTime))
    },
    formattedJobLength () {
      let startDate = moment(this.jobDetails.startDate).format('YYYY-MM-DD')
      let startTime = moment(this.jobDetails.startTime).format('HH:mm')
      let endDate = moment(this.jobDetails.endDate).format('YYYY-MM-DD')
      let endTime = moment(this.jobDetails.endTime).format('HH:mm')
      let start = moment(startDate + ' ' + startTime)
      let end = moment(endDate + ' ' + endTime)
      let hrs = moment(end).diff(moment(start), 'hours')
      let mins = moment(end).diff(moment(start), 'minutes') % 60
      return `${hrs}h ${mins}m`
    },
    existingJobOverlap () {
      // No jobs or incomplete input? No overlap.
      console.log('Checking existing job overlap...')
      console.log(this.totalJobList)
      if (!Array.isArray(this.totalJobList) || this.totalJobList.length === 0) return false
      if (!this.jobDetails.startDate || !this.jobDetails.startTime) return false

      // Build new interval (local; use utc() if that’s your standard)
      const newStart = moment(`${moment(this.jobDetails.startDate).local().format('YYYY-MM-DD')} ${moment(this.jobDetails.startTime).local().format('HH:mm')}`, 'YYYY-MM-DD HH:mm')
      let newEnd = null

      // If end date/time is empty, treat as a single point in time (start only)
      if (this.jobDetails.endDate && this.jobDetails.endTime) {
        newEnd = moment(`${moment(this.jobDetails.endDate).local().format('YYYY-MM-DD')} ${moment(this.jobDetails.endTime).local().format('HH:mm')}`, 'YYYY-MM-DD HH:mm')
      }

      console.log('Checking overlap for new job ' + newStart.format() + (newEnd ? ' → ' + newEnd.format() : ' (no end)'))

      if (!newStart.isValid()) return false
      if (newEnd && !newEnd.isValid()) return false
      if (newEnd && !newEnd.isAfter(newStart)) return false // zero/negative length: treat as invalid/no overlap

      // Normalise currentJobID to a number if possible
      const currentId = typeof this.currentJobID === 'string' ? parseInt(this.currentJobID, 10) : this.currentJobID

      for (const job of this.totalJobList) {
        if (currentId !== -1 && job.job_id === currentId) continue // skip the one we’re editing

        const jobStart = moment(job.start_time, 'YYYY-MM-DD HH:mm:ss').local()
        // If no end_time, treat as "still running" → use now OR shiftEnd if you prefer
        const jobEnd = job.end_time ? moment(job.end_time, 'YYYY-MM-DD HH:mm:ss').local() : (this.shiftEndTime ? moment(this.shiftEndTime, 'YYYY-MM-DD HH:mm') : moment())

        console.log('Comparing to existing job ' + jobStart.format() + ' → ' + jobEnd.format())

        if (!jobStart.isValid()) continue // skip bad rows
        if (!jobEnd.isValid()) continue

        if (newEnd) {
          // Overlap if ranges intersect (exclusive at the boundary)
          const overlaps = newStart.isBefore(jobEnd) && newEnd.isAfter(jobStart)
          if (overlaps) return true
        } else {
          // No end: check if newStart falls within any existing job interval
          const overlaps = newStart.isSameOrAfter(jobStart) && newStart.isBefore(jobEnd)
          if (overlaps) return true
        }
      }
      return false
    }
  },
  methods: {
    stripDecimals (value) {
      if (value !== null && value !== '') {
        this.jobDetails.spray_bonus = Math.floor(Number(value)) || 0
      }
    },
    startJob () {
      if (!this.$refs.form.validate()) {
        return
      }

      // Ensure jobs have been loaded before checking overlap
      if (!this.jobsLoaded) {
        return
      }

      // Explicit overlap check as a safeguard
      if (this.existingJobOverlap) {
        this.validateForm()
        return
      }

      this.loading = true
      var jobDetails = JSON.parse(JSON.stringify(this.jobDetails)) // deep clone to avoid mutating original object
      jobDetails.startDate = moment.utc(jobDetails.startDate).format('YYYY-MM-DD') + ' ' + moment.utc(jobDetails.startTime).format('HH:mm')
      if (jobDetails.endDate !== null && jobDetails.endTime !== null) { // if end date and time are set
        jobDetails.endDate = moment.utc(jobDetails.endDate).format('YYYY-MM-DD') + ' ' + moment.utc(jobDetails.endTime).format('HH:mm')
      }
      axios.post(this.url + `/tanda-service/saveJobDetails.ajax.php`, {
        company: this.company,
        type: 1, // initial add
        jobDetails: jobDetails

      })
        .then(response => {
          this.jobState = 1
          this.loading = false
          this.jobDetails.job_id = response.data
        })
        .catch(e => {
          this.loading = false
          this.saveFailedDialog = true
          console.log(e)
        })
    },
    getShiftTimes () {
      this.loading = true
      axios.post(this.url + `/tanda-service/getCurrentJobList.ajax.php`, {
        company: this.company,
        type: 'current',
        ta_id: this.taID,
        currentJobID: this.currentJobID
      })
        .then(response => {
          this.shiftStartTime = response.data.shiftDetails.start_time !== null ? moment(response.data.shiftDetails.start_time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm') : null
          this.shiftEndTime = response.data.shiftDetails.end_time !== null ? moment(response.data.shiftDetails.end_time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm') : null
          console.log(this.shiftStartTime)
          if (this.shiftInProgress === '0') {
            this.jobDetails.startDate = this.shiftStartTime.split(' ')[0]
            this.jobDetails.startTime = moment(this.shiftStartTime).toDate()
            this.jobDetails.endDate = this.shiftStartTime.split(' ')[0]
            this.jobDetails.endTime = moment(this.shiftStartTime).toDate()
          }
          this.jobList = response.data.jobDetails
        })
        .catch(e => {
          this.failedDialog = true
          console.log(e)
        })
    },
    getCurrentJobDetails () {
      this.loading = true
      axios.post(this.url + `/tanda-service/getCurrentJobList.ajax.php`, {
        company: this.company,
        type: 'current',
        ta_id: this.taID,
        currentJobID: this.currentJobID
      })
        .then(response => {
          this.jobList = response.data.jobDetails
          this.jobStartTime = moment.utc(response.data.jobDetails[0].start_time, 'YYYY-MM-DD HH:mm:ss').local().toDate()
          this.shiftStartTime = moment(response.data.shiftDetails.start_time, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD HH:mm')
          this.shiftEndTime = response.data.shiftDetails.end_time !== null ? moment(response.data.shiftDetails.end_time, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD HH:mm') : null
          if (response.data.jobDetails.length > 0) { // shift has already been started
            let currentJob = response.data.jobDetails[0]
            this.jobState = 1 // shift started
            this.jobDetails.startDate = moment.utc(currentJob.start_time, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD')
            this.jobDetails.startTime = moment.utc(currentJob.start_time, 'YYYY-MM-DD HH:mm:ss').local().toDate()
            this.jobDetails.job_id = currentJob.job_id
            this.jobDetails.farm = currentJob.farm_id
            this.jobDetails.jobDescription = currentJob.job_desc_id
            this.jobDetails.productSpec = currentJob.product_spec_id
            this.jobDetails.spray_bonus = currentJob.spray_bonus
            if (currentJob.end_time !== null) {
              this.jobState = 2 // job ended
              this.endJobActive = true
              this.jobDetails.endDate = moment.utc(currentJob.end_time, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD')
              this.jobDetails.endTime = moment.utc(currentJob.end_time, 'YYYY-MM-DD HH:mm:ss').local().toDate()
            } else {
              if (this.shiftInProgress === '0') {
                this.jobDetails.endDate = this.shiftEndTime.split(' ')[0]
                this.jobDetails.endTime = moment(this.shiftEndTime, 'YYYY-MM-DD HH:mm').toDate()
              } else {
                this.jobDetails.endDate = null
                this.jobDetails.endTime = null
              }
            }
            this.jobDetails.ta_id = currentJob.ta_id
          }
          this.loading = false
        })
        .catch(e => {
          this.failedDialog = true
          console.log(e)
        })
    },
    getAllJobs () {
      axios.post(this.url + `/tanda-service/getCurrentJobList.ajax.php`, {
        company: this.company,
        type: 'all',
        ta_id: this.taID,
        currentJobID: '-1'
      })
        .then(response => {
          this.totalJobList = response.data.jobDetails
          this.jobsLoaded = true
          this.validateForm()
        })
        .catch(e => {
          this.failedDialog = true
          this.jobsLoaded = true
          console.log(e)
        })
    },
    retrieveJobInfo () {
      this.loading = true
      axios.post(this.url + `/tanda-service/getJobDetails.ajax.php`, {
        company: this.company
      })
        .then(response => {
          this.loading = false
          this.jobInfo = response.data
        })
        .catch(e => {
          this.failedDialog = true
          this.loading = false
          console.log(e)
        })
    },
    formatTimeStringToDate (val) {
      return moment(val, 'HH:mm').toDate()
    },
    openEndDialog () {
      if (this.shiftInProgress === '0') {
        this.jobDetails.endDate = this.shiftEndTime.split(' ')[0]
        this.jobDetails.endTime = moment(this.shiftEndTime, 'YYYY-MM-DD HH:mm').toDate()
      } else {
        this.jobDetails.endDate = moment().format('YYYY-MM-DD')
        this.jobDetails.endTime = moment().toDate()
      }
      this.endJobActive = true
    },
    deleteJob () {
      this.loading = true
      axios.post(this.url + `/tanda-service/saveJobDetails.ajax.php`, {
        company: this.company,
        type: 3, // remove
        jobDetails: this.jobDetails
      })
        .then(response => {
          this.loading = false
          this.jobDetails.farm = null
          this.jobDetails.spray_bonus = null
          this.jobDetails.jobDescription = null
          this.jobDetails.productSpec = null
          if (this.shiftInProgress === '0') {
            this.jobDetails.startDate = this.shiftStartTime.split(' ')[0]
            this.jobDetails.startTime = moment(this.shiftStartTime, 'YYYY-MM-DD HH:mm').toDate()
          } else {
            this.jobDetails.startDate = moment().format('YYYY-MM-DD')
            this.jobDetails.startTime = moment().toDate()
          }
          this.jobDetails.endDate = null
          this.jobDetails.endTime = null
          this.jobDetails.job_id = null
          this.endJobActive = false
          this.jobState = 0
          this.$router.back()
        })
        .catch(e => {
          this.loading = false
          this.saveFailedDialog = true
          console.log(e)
        })
    },
    completeJob () { // ending job
      if (!this.$refs.form.validate()) {
        return
      }

      if (!this.jobsLoaded) {
        return
      }

      if (this.existingJobOverlap) {
        this.validateForm()
        return
      }

      this.loading = true
      var jobDetails = JSON.parse(JSON.stringify(this.jobDetails)) // deep clone to avoid mutating original object
      jobDetails.startDate = moment.utc(jobDetails.startDate).format('YYYY-MM-DD') + ' ' + moment.utc(jobDetails.startTime).format('HH:mm')
      jobDetails.endDate = moment.utc(jobDetails.endDate).format('YYYY-MM-DD') + ' ' + moment.utc(jobDetails.endTime).format('HH:mm')
      axios.post(this.url + `/tanda-service/saveJobDetails.ajax.php`, {
        company: this.company,
        type: 2, // 2 - Update of existing job
        jobDetails: jobDetails
      })
        .then(response => {
          this.jobState = 2
          this.loading = false
          if (this.currentJobID !== -1 && this.currentJobID !== '-1') {
            this.$router.back()
          } else {
            this.completeDialog = true
            this.getCurrentJobDetails()
          }
        })
        .catch(e => {
          this.loading = false
          this.saveFailedDialog = true
          console.log(e)
        })
    },
    formatTimeDateToString (val) {
      return moment(val).format('HH:mm')
    },
    validateForm () {
      console.log('Validating form...')
      this.$refs.form.validate()
    }
  },
  filters: {
    formatDate (val) {
      return val !== undefined ? moment(val).format('DD/MM/YYYY HH:mm') : '--'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/JobDetails.vue